import {createFeature, createReducer, on} from "@ngrx/store";
import {APP_CONSTANTS} from "../../app.constants";
import {FilterInterface, PaginationInfoInterface, TrumpfCompanyModel} from "../../interfaces";
import * as TrumpfCompanyActions from "../actions/trumpf-companies.actions";

export const trumpfCompaniesFeatureKey = "TrumpfCompanies";

export interface State {
  trumpfCompanyItems: Array<TrumpfCompanyModel>;
  trumpfCompanyItemsPaginated: Array<TrumpfCompanyModel>;
  trumpfCompanyFilters: FilterInterface;
  trumpfCompanyPaginationInfo: PaginationInfoInterface;
}

export const initialState: State = {
  trumpfCompanyItems: [],
  trumpfCompanyItemsPaginated: [],
  trumpfCompanyFilters: {
    limit: APP_CONSTANTS.PAGINATION_PAGE_SIZE,
    offset: 0
  },
  trumpfCompanyPaginationInfo: {
    from: 0,
    to: 0,
    totalResults: 0,
    currentPage: 0,
    totalPages: 1
  }
};

export const trumpfCompaniesFeature = createFeature({
  name: trumpfCompaniesFeatureKey,
  reducer: createReducer(
    initialState,
    on(
      TrumpfCompanyActions.addTrumpfCompany,
      (state: State, {trumpfCompany}): State => ({
        ...state,
        trumpfCompanyItems: [...state.trumpfCompanyItems, trumpfCompany]
      })
    ),
    on(
      TrumpfCompanyActions.addTrumpfCompanies,
      (state: State, {trumpfCompanies}): State => ({
        ...state,
        trumpfCompanyItems: [...state.trumpfCompanyItems, ...trumpfCompanies]
      })
    ),
    on(TrumpfCompanyActions.updateTrumpfCompany, (state: State, {trumpfCompany}): State => {
      const trumpfCompanies = state.trumpfCompanyItems.map(item =>
        item.shortCode === trumpfCompany.shortCode ? trumpfCompany : item
      );
      return {
        ...state,
        trumpfCompanyItems: trumpfCompanies
      };
    }),
    on(
      TrumpfCompanyActions.setTrumpfCompanies,
      (state: State, {trumpfCompanies}): State => ({
        ...state,
        trumpfCompanyItems: trumpfCompanies
      })
    ),
    on(
      TrumpfCompanyActions.setPaginatedTrumpfCompanies,
      (state: State, {trumpfCompanies}): State => ({
        ...state,
        trumpfCompanyItemsPaginated: trumpfCompanies
      })
    ),
    on(
      TrumpfCompanyActions.setTrumpfCompaniesPaginationInfo,
      (state: State, {paginationInfo}): State => ({...state, trumpfCompanyPaginationInfo: paginationInfo})
    ),
    on(
      TrumpfCompanyActions.gotoTrumpfCompaniesPage,
      (state: State, {page}): State => ({
        ...state,
        trumpfCompanyFilters: {...state.trumpfCompanyFilters, offset: state.trumpfCompanyFilters.limit * (page - 1)},
        trumpfCompanyPaginationInfo: {...state.trumpfCompanyPaginationInfo, currentPage: page}
      })
    ),
    on(TrumpfCompanyActions.applyTrumpfCompaniesFilters, (state: State, {filters}): State => {
      const newFilters = {...state.trumpfCompanyFilters};
      filters.forEach(({key, value}) => {
        newFilters[key as string] = value;
      });
      newFilters.offset = 0;
      return {...state, trumpfCompanyFilters: newFilters};
    }),
    on(
      TrumpfCompanyActions.resetTrumpfCompaniesFilters,
      (state: State): State => ({...state, trumpfCompanyFilters: initialState.trumpfCompanyFilters})
    )
  )
});

export const {
  name,
  reducer,
  selectTrumpfCompaniesState,
  selectTrumpfCompanyItems,
  selectTrumpfCompanyItemsPaginated,
  selectTrumpfCompanyFilters,
  selectTrumpfCompanyPaginationInfo
} = trumpfCompaniesFeature;
